module.exports = __webpack_public_path__ + "img/f5eb72996927c52464859bee180a5066.png";